export const environment = {
  production: false,
  development: true,
  apiEndpoint: 'https://dev-packcert-api.gesvatec.com/api',
  intraWebUrl: 'https://dev-packcert.gesvatec.com/home',
  helpCenterUrl: 'https://gesvadesk.intapp.gesvatec.com/s/packcert'
};
